export default __webpack_public_path__ + "static/media/Spectrum-PM-ComponentStatus.0db10db2.png";